import * as actionTypes from "../actionTypes";
import * as ImmersionGQL from "../../../gql";

// experience List Success
const participantExperiencesGetSuccess = (items: any) => ({
	type: actionTypes.PARTICIPANT_EXPERIENCES_GET_SUCCESS,
	payload: items,
});

export const updatePage = (page: number) => ({
	type: actionTypes.UPDATE_PAGE,
	payload: page
});

export const setLoading = (value: any) => ({
	type: actionTypes.SET_PARTICIPENT_EXPERIENCE_LOADING,
	payload: value,
});

// update Participant planning
export const updateParticipantPlanning = (param: string, value: string) => ({
	type: actionTypes.UPDATE_PLANNING_VALUE,
	payload: {
		param,
		value
	},
});


//get experience list
export const participantExperiences = (client: any, req: any) => {
	return (dispatch: any) => {
		dispatch(setLoading(true));
		client.query({
			query: ImmersionGQL.queryParticipantExperiences,
			fetchPolicy: "no-cache",
			variables: {
				page_no: req.page,
				size: req.size
			}
		})
			.then((response: any) => {
				if (response.data.participantExperiences) {
					dispatch(participantExperiencesGetSuccess(response.data.participantExperiences));
				}
				dispatch(setLoading(false));
			})
			.catch(() => { })
	}
};

//send email template
export const sendEmailTemplate = (client: any, objectData: JSON, cb: any) => {
	return () => {
		client.query({
			query: ImmersionGQL.querySendEmailTemplate,
			fetchPolicy: "no-cache",
			variables: {
				template_type: "new_participant_with_no_experiences",
				objectData: objectData
			}
		})
			.then((response: any) => {
				if (response.data.sendEmailTemplate) {
					cb(response.data.sendEmailTemplate)
				}
			})
			.catch(() => {
				cb(false)
			})
	}
};

// add Participants By session Code
export const addParticipantsBysessionCode = (client: any, request: any, response: any) => {
	return () => {
		client.mutate({
			mutation: ImmersionGQL.mutationAddParticipantsBysessionCode,
			fetchPolicy: "no-cache",
			variables: {
				session_code: request.session_code,
				email: request.email,
			}
		}).then((res: any) => {
			response(res.data.addParticipantsBysessionCode)
		}).catch(() => {
			response({ status: "false", message: "" })
		})
	}
};

export const addWebWidgetParticipantsBysessionCode = (client: any, request: any, response: any) => {
	return () => {
		client.mutate({
			mutation: ImmersionGQL.mutationjoinSessionCode,
			fetchPolicy: "no-cache",
			variables: {
				session_code: request.session_code,
				identifier: request.identifier,
				temp_email: request.temp_email,
			}
		}).then((res: any) => {
			if (!!res.data.joinSessionCode.data) {
				Object.assign(res.data.joinSessionCode.data, { device_id: request.deviceId })
			}
			response(res.data.joinSessionCode)
		}).catch(() => {
			response({ status: "false", message: "" })
		})
	}
};

export const checkConnectedSessions = (client: any, request: any, response: any) => {
	return () => {
		client.query({
			query: ImmersionGQL.querygetConnectedSessions,
			fetchPolicy: "no-cache",
			variables: {
				session_code: request.session_code,
			}
		}).then((res: any) => {
			response(res.data.getConnectedSessions)
		}).catch(() => {

		})
	}
};